import React from "react";
import {
  Modal,
  Select,
  DatePicker,
  Radio,
  InputNumber,
  TreeSelect,
} from "antd";
import moment from "moment";
const { Option } = Select;

export const BorrowItemModal = ({
  title,
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
}) => {
  return (
    <div>
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h3 className="modaltitle">{title}</h3>
        </div>
        <div
          style={{
            maxHeight: "25rem",
            overflow: "scroll",
            padding: "8px",
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Item Name</h3>
            <input
              className="roleInput"
              placeholder="Item Name"
              name="itemName"
              value={data && data.itemName}
              id="itemName"
              onChange={(e) => {
                e.preventDefault();
                handleChange("itemName", e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Loaner Name <span style={{ color: "red" }}>*</span></h3>
            <input
              className="roleInput"
              placeholder="Loaner Name"
              name="loanerName"
              value={data && data.loanerName}
              id="loanerName"
              onChange={(e) => {
                e.preventDefault();
                handleChange("loanerName", e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Loaner Phone Number</h3>
            <input
              className="roleInput"
              placeholder="Loaner Phone Number"
              name="loanerPhoneNumber"
              value={data && data.loanerPhoneNumber}
              id="loanerPhoneNumber"
              onChange={(e) => {
                e.preventDefault();
                handleChange("loanerPhoneNumber", e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Loan Date <span style={{ color: "red" }}>*</span>
            </h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="Loan Date"
              name="loanDate"
              value={data && data.loanDate && moment.utc(data.loanDate)}
              id="newDate"
              onChange={(date, dateString) => {
                handleChange("loanDate", dateString);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Return Date <span style={{ color: "red" }}>*</span>
            </h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="Return Date"
              name="returnDate"
              value={data && data.returnDate && moment.utc(data.returnDate)}
              id="newDate"
              onChange={(date, dateString) => {
                handleChange("returnDate", dateString);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Details</h3>
            <input
              className="roleInput"
              placeholder="Enter Details Here"
              name="details"
              value={data && data.details}
              id="details"
              onChange={(e) => {
                e.preventDefault();
                handleChange("details", e.target.value);
              }}
            />
          </div>
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={!data || !data.loanDate || !data.returnDate || !data.itemName}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
